export const PATH_NAME = {
  ROOT: "/",
  LOGIN: "/login",
  META_TAGS: "/meta-tags",
  GOOGLE: "/google",
  GOOGLE_PERFORMANCE: "/google-performance",
  GOOGLE_SITEMAPS: "/google-sitemaps",
  SITEMAP: "/sitemap",
  SITE_VERIFICATIONS: "/site-verifications",
  NOT_FOUND_PAGES: "/not-found-pages",
  PAGE_SPEED_INSIGHTS: "/page-speed-insights",
  AUTOKETING_APPS: "/autoketing-apps",
  WELCOME: "/welcome",
  ADD_NEW: "/campaigns/add-new",
  DETAIL_CAMPAIGN: "/campaign/:id",
  LIST_CAMPAIGN: "/list-campaign",
  DASHBOARD: "/dashboard",
  PRICING: "/pricing",
};
